<template>
  <div class="col-xs-12 col-md-12">
    <div v-if="flagDisplayPanes" class="row">  

            <div class="block">
                <ul class="nav nav-tabs nav-tabs-alt" data-toggle="tabs">
                    <li v-for="(pane,index) in panes" v-bind:class="tabTitleClass[index]">
                        <a @click="switchPane(index)">{{pane.buttonLabel[actualLanguage]}}</a>
                    </li>

                </ul>
                <div class="block-content tab-content">
                    <div v-for="(pane,index1) in panes" v-bind:class="tabContentClass[index1]">
                        <h3 class="font-w300 push-15"> {{pane.title[actualLanguage]}}</h3>

                          <!-- ------------------------- -->
                          <!-- Section des tuiles-->
                          <!-- ------------------------- -->
                          <div v-for="tile in pane.tilesIndicator" class="col-xs-6 col-sm-4 col-lg-3">
                              <a class="block block-link-hover2 text-center">
                                  <div class="block-content block-content-full" v-bind:class="tile.colorBackground">
                                      <div class="font-w600 text-white-op push-5-t">{{tile.label[actualLanguage]}}</div>
                                      <i v-bind:class="tile.favIcon" class="fa-2x text-white"></i>
                                      <div class="h4 text-white">{{tile.value}} {{tile.valueSufix}}</div>
                                  </div>
                              </a>
                          </div>
                          


                          <!-- ------------------------- -->
                          <!-- Section des graphiques superposés-->
                          <!-- ------------------------- -->
                          <div v-for="graph in pane.graphs">

                            <div v-if="graph.type=='LineSingle'" class="row"> 
                              <api-device-graph-line-single-v1p00  :graphData="graph" ></api-device-graph-line-single-v1p00>
                            </div>


                            <div v-if="graph.type=='LineMultiple'" class="row"> 
                              <api-device-graph-line-multiple-v1p00  :graphData="graph" ></api-device-graph-line-multiple-v1p00>
                            </div>

                            <div v-if="graph.type=='BarSingle'" class="row"> 
                              <api-device-graph-bar-single-v1p00  :graphData="graph" ></api-device-graph-bar-single-v1p00>
                            </div>

                            <div v-if="graph.type=='BarMultiple'" class="row"> 
                              <api-device-graph-bar-multiple-v1p00  :graphData="graph" ></api-device-graph-bar-multiple-v1p00>
                            </div>

                          </div>


                    </div>
                </div>
            </div>

    </div>

  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'
import ApiDeviceGraphLineSingleV1p00 from './ApiDeviceGraphLineSingleV1p00.vue'
import ApiDeviceGraphLineMultipleV1p00 from './ApiDeviceGraphLineMultipleV1p00.vue'
import ApiDeviceGraphBarSingleV1p00 from './ApiDeviceGraphBarSingleV1p00.vue'
import ApiDeviceGraphBarMultipleV1p00 from './ApiDeviceGraphBarMultipleV1p00.vue'

export default {
  props: ['panes'], //tableau : {buttonLabel,title,tilesIndicators,graphs}
  components: {
    ApiDeviceGraphLineSingleV1p00,
    ApiDeviceGraphLineMultipleV1p00,
    ApiDeviceGraphBarSingleV1p00,
    ApiDeviceGraphBarMultipleV1p00,
  },
  data() {
    return {
      actualLanguage : "FR",
      testColor : '#46c37b',
      flagDisplayPanes : false,
      tabTitleClass : ['','active','',''],
      tabContentClass : ['tab-pane','tab-pane active','tab-pane'],
    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData']),
  },
  watch: {


  },
  methods: {
  
    switchPane(index){
      for(var m=0;m<this.tabTitleClass.length;m++){
        this.tabTitleClass[m]=''
        this.tabContentClass[m]='tab-pane'
      }
      this.tabTitleClass[index]='active'
      this.tabContentClass[index]='tab-pane active'
      this.flagDisplayPanes = false
      this.$nextTick(() => {this.flagDisplayPanes = true});
    },

    },



  mounted() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.tabTitleClass = []
    this.tabContentClass = []

    this.flagDisplayPanes = false
    console.log("Pane mount 1")
    console.log(this.panes)
    for(var m=0;m<this.panes.length;m++)
    {
      this.tabTitleClass.push('')
      this.tabContentClass.push('tab-pane')
    }
    console.log("Pane mount 2")
    this.tabTitleClass[0]='active'
    this.tabContentClass[0]='tab-pane active'

    this.$nextTick(() => {this.flagDisplayPanes = true});

  },



}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ApiDevicePanesV1p00.vue?0e014ea0